var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_4872_1586_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0147061 -0.0120051 0 12.0051 14.7061)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1007.97,
    y: -1007.97,
    width: 2015.93,
    height: 2015.93
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(41, 47, 61, 1) 0deg,rgba(95, 108, 139, 1) 180.298deg,rgba(41, 46, 60, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96206 4.40522L10.7419 0.572737C11.5783 0.207672 12.5292 0.209065 13.3644 0.576578L22.0591 4.40223C23.2448 4.92393 24.0102 6.0961 24.0102 7.39147V15.1126C24.0102 23.2048 16.0214 27.6221 13.1042 28.9654C12.43 29.2758 11.6722 29.2937 10.9879 29.0063C8.01264 27.7566 -0.154294 23.4773 0.00221865 14.2039V7.39912C0.00221865 6.10028 0.771684 4.92483 1.96206 4.40522Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.16078431904315948,\"g\":0.18431372940540314,\"b\":0.23921568691730499,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.37526041269302368,\"g\":0.42565694451332092,\"b\":0.54583334922790527,\"a\":1.0},\"position\":0.50082647800445557},{\"color\":{\"r\":0.16229166090488434,\"g\":0.18377976119518280,\"b\":0.23749999701976776,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.16078431904315948,\"g\":0.18431372940540314,\"b\":0.23921568691730499,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.37526041269302368,\"g\":0.42565694451332092,\"b\":0.54583334922790527,\"a\":1.0},\"position\":0.50082647800445557},{\"color\":{\"r\":0.16229166090488434,\"g\":0.18377976119518280,\"b\":0.23749999701976776,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":8.6740908713015506e-15,\"m01\":-24.010162353515625,\"m02\":24.010162353515625,\"m10\":29.412122726440430,\"m11\":7.6817663626047201e-15,\"m12\":-1.7795055100577883e-06},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4872_1586)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.006,
    cy: 12.4816,
    r: 3.44305,
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4761 15.4473H13.6315V18.8416C13.6315 19.7129 12.9251 20.4193 12.0538 20.4193C11.1825 20.4193 10.4761 19.7129 10.4761 18.8416V15.4473Z",
    fill: "#97A1C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_4872_1586_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96206 4.40522L10.7419 0.572737C11.5783 0.207672 12.5292 0.209065 13.3644 0.576578L22.0591 4.40223C23.2448 4.92393 24.0102 6.0961 24.0102 7.39147V15.1126C24.0102 23.2048 16.0214 27.6221 13.1042 28.9654C12.43 29.2758 11.6722 29.2937 10.9879 29.0063C8.01264 27.7566 -0.154294 23.4773 0.00221865 14.2039V7.39912C0.00221865 6.10028 0.771684 4.92483 1.96206 4.40522Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4872_1586",
    x: 8.56296,
    y: 9.03857,
    width: 6.88611,
    height: 11.8589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.478246
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.205382 0 0 0 0 0.21961 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4872_1586"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotpIcon);
export default __webpack_public_path__ + "static/media/totp-icon.a94ac6bf1f811ce193483970660bbb5a.svg";
export { ForwardRef as ReactComponent };